import { render, staticRenderFns } from "./ClassContent.vue?vue&type=template&id=1ae1a7dd&"
import script from "./ClassContent.vue?vue&type=script&lang=js&"
export * from "./ClassContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports